export default {
    localizationScreenGroups: [],
    localizationScreenGroupsLoading: false,
}
